import React, { useState, useEffect, useRef } from 'react';
import { FileText, ChevronDown, Check } from 'lucide-react';

export default function TemplateControl({ templates, value, onChange }) {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const active = templates.find(t => t.value === value) || templates[0];

  return (
    <div className="mic-control" ref={containerRef}>
      <button
        className={`mic-pill${open ? ' mic-pill--open' : ''}`}
        onClick={() => setOpen(o => !o)}
        title="Report template"
        type="button"
      >
        <FileText size={13} color="#6b7280" />
        <span style={{ fontWeight: 500 }}>{active.label}</span>
        <ChevronDown size={13} className={`mic-pill__chevron${open ? ' mic-pill__chevron--up' : ''}`} />
      </button>

      {open && (
        <div className="mic-dropdown">
          <div className="mic-dropdown__header">Template</div>
          <ul className="mic-dropdown__list">
            {templates.map(t => {
              const isActive = value === t.value;
              return (
                <li key={t.value}>
                  <button
                    className={`mic-dropdown__item${isActive ? ' mic-dropdown__item--active' : ''}`}
                    onClick={() => { onChange(t.value); setOpen(false); }}
                    type="button"
                  >
                    <Check size={13} className="mic-dropdown__check" style={{ opacity: isActive ? 1 : 0 }} />
                    <span>{t.label}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
}
